// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import moment from 'moment'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import apiUrl from '../../../../configs/constant';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [tabs, setTabs] = useState<string>("0")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valCustomerClass, setValCustomerClass] = useState<any>(null)
    const [listCustomerClass, setListCustomerClass] = useState<any[]>([])

    const [valSalesman, setValSalesman] = useState<any>(null)
    const [listSalesman, setListSalesman] = useState<any[]>([])

    const [valCustomer, setValCustomer] = useState<any>(null)
    const [listCustomer, setListCustomer] = useState<any[]>([])

    const [listDetail, setListDetail] = useState<any[]>([])

    useEffect(() => {
        getDetail()
    }, [])

    const navigate = useNavigate();

    const getDetail = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/sales/customer/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    setValue('alamat', data.alamat)
                    setValue('email', data.email)
                    setValue('is_ktp', data.is_ktp)
                    setValue('nama', data.nama)
                    setValue('nama2', data.nama2)
                    setValue('nama_bank', data.nama_bank)
                    setValue('nomor_bank', data.nomor_bank)
                    setValue('npwp', data.npwp)
                    setValue('payment', data.payment)
                    setValue('plafon', data.plafon)
                    setValue('sdcust_class_id', data.sdcust_class_id)
                    setValue('sdcust_id', data.sdcust_id)
                    setValue('sdsalesman_id', data.sdsalesman_id)
                    setValue('sysdoctag_id', data.syscabang_id)
                    setValue('telp', data.telp)
                    setValue('wa', data.wa)

                    Swal.close()

                    getDoctag(data.sysdoctag_id)
                    getCustomerClass(data.sdcust_class_id)
                    getSalesman(data.sdsalesman_id)
                    getCustomer(data.sdcust_id)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getDoctag = (ids: any) => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 30
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValDoctag(element)
                        }
                    });
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getCustomerClass = (ids: any) => {
        const url = apiUrl.apiUrl + '/sales/customer-class/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValCustomerClass(element)
                        }
                    });
                    setListCustomerClass(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getSalesman = (ids: any) => {
        const url = apiUrl.apiUrl + '/sales/salesman/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValSalesman(element)
                        }
                    });
                    setListSalesman(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getCustomer = (ids: any) => {
        const url = apiUrl.apiUrl + '/sales/customer/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValCustomer(element)
                        }
                    });
                    setListCustomer(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getSalesHistory = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/sales/customer/sales-hist/' + id
        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDetail(data)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                    // Swal.close()
                }
            })
    }


    const getArHistory = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/sales/customer/ar-hist/' + id
        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDetail(data)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                    // Swal.close()
                }
            })

    }

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAutocompleteCustomerClass = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdcust_class_id', newValue?.id)
        setValCustomerClass(newValue)
    }

    const handleChangeAutocompleteSalesman = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdsalesman_id', newValue?.id)
        setValSalesman(newValue)
    }

    const handleChangeAutocompleteCustomer = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdcust_id', newValue?.id)
        setValCustomer(newValue)
    }


    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        sdcust_class_id: any,
        sdsalesman_id: any,
        sdcust_id: any,
        nama: any,
        nama2: any,
        alamat: any,
        telp: any,
        wa: any,
        is_ktp: any,
        npwp: any,
        email: any,
        nama_bank: any,
        nomor_bank: any,
        payment: any,
        plafon: any
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/customer/edit/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/sales/master-customer')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Master Customer
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='centered tabs'
                            sx={{
                                my: 3,
                                justifyContent: 'center', // center horizontal
                                display: 'flex',
                                gap: 2 // jarak antar tab
                            }}
                        >
                            <Tab
                                value='0'
                                label='DATA'
                                icon={<Icon icon={"mdi:file-document-outline"} />}
                                sx={{ minWidth: 'fit-content', flex: 1 }}
                                onClick={getDetail}
                            />
                            <Tab
                                value='1'
                                label='SALES HISTORY'
                                icon={<Icon icon={"mdi:cart-outline"} />}
                                sx={{ minWidth: 'fit-content', flex: 1 }}
                                onClick={getSalesHistory}
                            />
                            <Tab
                                value='2'
                                label='AR HISTORY'
                                icon={<Icon icon={"mdi:currency-usd"} />}
                                sx={{ minWidth: 'fit-content', flex: 1 }}
                                onClick={getArHistory}
                            />
                        </TabList>
                        <TabPanel value='0'>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Document Tag
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='sysdoctag_id'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <Autocomplete
                                                        value={valDoctag}
                                                        options={listDoctag}
                                                        id='sysdoctag_id'
                                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                        onChange={handleChangeAutocompleteDoctag}
                                                        renderOption={(props: any, option: any) => {
                                                            return (
                                                                <li {...props} key={option.id}>
                                                                    {option.nama}
                                                                </li>
                                                            )
                                                        }}
                                                        getOptionLabel={(option: any) => option.nama}
                                                        renderInput={(params: any) => (
                                                            <TextField
                                                                {...params}
                                                                label='Document Tag'
                                                                error={Boolean(errors.sysdoctag_id)}
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            />
                                            {errors.sysdoctag_id && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Kelas Customer
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='sdcust_class_id'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <Autocomplete
                                                        value={valCustomerClass}
                                                        options={listCustomerClass}
                                                        id='sdcust_class_id'
                                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                        onChange={handleChangeAutocompleteCustomerClass}
                                                        renderOption={(props: any, option: any) => {
                                                            return (
                                                                <li {...props} key={option.id}>
                                                                    {option.nama}
                                                                </li>
                                                            )
                                                        }}
                                                        getOptionLabel={(option: any) => option.nama}
                                                        renderInput={(params: any) => (
                                                            <TextField
                                                                {...params}
                                                                label='Kelas Customer'
                                                                error={Boolean(errors.sdcust_class_id)}
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            />
                                            {errors.sdcust_class_id && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Salesman
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='sdsalesman_id'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <Autocomplete
                                                        value={valSalesman}
                                                        options={listSalesman}
                                                        id='sdsalesman_id'
                                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                        onChange={handleChangeAutocompleteSalesman}
                                                        renderOption={(props: any, option: any) => {
                                                            return (
                                                                <li {...props} key={option.id}>
                                                                    {option.nama}
                                                                </li>
                                                            )
                                                        }}
                                                        getOptionLabel={(option: any) => option.nama}
                                                        renderInput={(params: any) => (
                                                            <TextField
                                                                {...params}
                                                                label='Salesman'
                                                                error={Boolean(errors.sdsalesman_id)}
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            />
                                            {errors.sdsalesman_id && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Customer Induk
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='sdcust_id'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <Autocomplete
                                                        value={valCustomer}
                                                        options={listCustomer}
                                                        id='sdcust_id'
                                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                        onChange={handleChangeAutocompleteCustomer}
                                                        renderOption={(props: any, option: any) => {
                                                            return (
                                                                <li {...props} key={option.id}>
                                                                    {option.nama}
                                                                </li>
                                                            )
                                                        }}
                                                        getOptionLabel={(option: any) => option.nama}
                                                        renderInput={(params: any) => (
                                                            <TextField
                                                                {...params}
                                                                label='Customer Induk'
                                                                required={false}
                                                                error={Boolean(errors.sdcust_id)}
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            />
                                            {errors.sdcust_id && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Nama Customer
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='nama'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Nama Customer'
                                                        error={Boolean(errors.nama)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.nama && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Nama Customer (Kode)
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='nama2'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Nama Customer (Kode)'
                                                        error={Boolean(errors.nama2)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.nama2 && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            NPWP
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='npwp'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='NPWP'
                                                        error={Boolean(errors.npwp)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.npwp && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            TOP
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='payment'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='TOP'
                                                        type='number'
                                                        error={Boolean(errors.payment)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.payment && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                justifyContent: 'flex-start'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                                    KTP ?
                                                </Typography>
                                                <FormControl fullWidth>
                                                    <Controller
                                                        name='is_ktp'
                                                        control={control}
                                                        rules={{ required: false }}
                                                        render={({ field: { value, onChange } }) => (
                                                            <FormControlLabel
                                                                sx={{ marginBottom: 0 }}
                                                                control={
                                                                    <Checkbox
                                                                        checked={Boolean(value)}
                                                                        onChange={e => {
                                                                            const isChecked = e.target.checked;
                                                                            onChange(isChecked ? 1 : 0);
                                                                        }}
                                                                        sx={errors.is_ktp ? { color: 'error.main' } : null}
                                                                    />
                                                                }
                                                                label='KTP ?'
                                                            />
                                                        )}
                                                    />
                                                    {errors.is_ktp && (
                                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Alamat Lengkap
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='alamat'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Alamat Lengkap'
                                                        multiline
                                                        rows={2}
                                                        error={Boolean(errors.alamat)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.alamat && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            No. HP (WA)
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='wa'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='No. HP (WA)'
                                                        error={Boolean(errors.wa)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.wa && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Telp
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='telp'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Telp'
                                                        error={Boolean(errors.telp)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.telp && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Email
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='email'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Email'
                                                        type='email'
                                                        error={Boolean(errors.email)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.email && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Nama Rekening
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='nama_bank'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Nama Rekening'
                                                        error={Boolean(errors.nama_bank)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.nama_bank && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Nomor Rekening
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='nomor_bank'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Nomor Rekening'
                                                        type='number'
                                                        error={Boolean(errors.nomor_bank)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.nomor_bank && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                            Plafon
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='plafon'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Plafon'
                                                        type='number'
                                                        error={Boolean(errors.plafon)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.plafon && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                                <Button variant='contained' type='submit'
                                                >
                                                    SIMPAN
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </form>
                        </TabPanel>
                        <TabPanel value='1'>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Tanggal Awal'
                                            type='date'
                                            onChange={(e) => setTglAwal(e.target.value)}
                                            value={tglAwal}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>

                                        <TextField
                                            label='Tanggal Akhir'
                                            type='date'
                                            onChange={(e) => setTglAkhir(e.target.value)}
                                            value={tglAkhir}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl fullWidth>
                                        <Button
                                            variant='contained'
                                            sx={{ mt: 1 }}
                                            startIcon={<Icon icon='mdi:magnify' />}
                                            onClick={getSalesHistory}
                                        >
                                            Cari Data
                                        </Button>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <MsiDatagrid key={1} array={listDetail} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Tanggal Awal'
                                            type='date'
                                            onChange={(e) => setTglAwal(e.target.value)}
                                            value={tglAwal}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>

                                        <TextField
                                            label='Tanggal Akhir'
                                            type='date'
                                            onChange={(e) => setTglAkhir(e.target.value)}
                                            value={tglAkhir}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl fullWidth>
                                        <Button
                                            variant='contained'
                                            sx={{ mt: 1 }}
                                            startIcon={<Icon icon='mdi:magnify' />}
                                            onClick={getSalesHistory}
                                        >
                                            Cari Data
                                        </Button>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <MsiDatagrid key={1} array={listDetail} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
        </Grid>
    )
}
